export const ALL_TICKETS_TAB_KEY = 'all_tickets';
export const PENDING_MY_ACTIONS_TAB_KEY = 'pending_my_actions';
export const WORK_TICKET_CREATED_EVENT = 'work_ticket_created';

export const WORK_TICKET_STATUS = {
  Ongoing: 10,
  Appealed: 15,
  Pending: 20,
  Done: 30,
  Cancel: 40,
  Rejected: 50,
} as const;

export const WORK_TICKET_ACTION_CODE = {
  TakeOver: 1,
  Approve: 2,
  Reject: 3,
  Cancel: 4,
} as const;

export const WORK_TICKET_ACTION_SOURCE = {
  WorkCenter: 1,
  CreatorDevice: 2,
} as const;

export const WORK_TICKET_FIELD_TYPE = {
  DeviceId: 3,
  SkuId: 4,
  TextRemark: 5,
  SkipRefTaskId: 103,
  SkipExpectedQty: 105,
  // Legacy field types retained for tickets created before field reuse.
  SkipConfirmTaskId: 106,
  SkipConfirmOrderNo: 107,
  SkipConfirmExpectedQty: 108,
  SkipConfirmRelatedDocumentId: 109,
} as const;

export const WORK_TICKET_PROCESS = {
  SalesOutbound: 2,
} as const;

export const WORK_TICKET_STAGE = {
  Checking: 2,
  Sorting: 3,
} as const;

export const OB_SKIP_CONFIRM_TICKET_TYPE = {
  Sorting: 'Skip Sorting Confirm',
  Checking: 'Skip Checking Confirm',
} as const;

export const OB_SKIP_CONFIRM_TICKET_TYPES = {
  [OB_SKIP_CONFIRM_TICKET_TYPE.Sorting]: WORK_TICKET_STAGE.Sorting,
  [OB_SKIP_CONFIRM_TICKET_TYPE.Checking]: WORK_TICKET_STAGE.Checking,
} as const;

export const WORK_TICKET_ACTIONABLE_STATUS: number[] = [
  WORK_TICKET_STATUS.Ongoing,
  WORK_TICKET_STATUS.Pending,
];

export type TicketTabKey =
  | typeof ALL_TICKETS_TAB_KEY
  | typeof PENDING_MY_ACTIONS_TAB_KEY;

export const getActiveTabKey = (tab?: string): TicketTabKey => {
  return tab === PENDING_MY_ACTIONS_TAB_KEY
    ? PENDING_MY_ACTIONS_TAB_KEY
    : ALL_TICKETS_TAB_KEY;
};
